<template>
    <div class="page-Loader" v-show="showLoader" :style="{width: width}"></div>
</template>

<script>
import { timeoutPromise } from 'services/utils/promises';

export default {
    name: 'Loader',
    props: {
        isLoading: Boolean
    },
    data() {
        return {
            showLoader: false,
            incTimeout: null,
            barPercentageValue: 0,
            started: false,
            width: 0
        };
    },
    watch: {
        isLoading(newVal, oldVal) {
            if (newVal !== oldVal) {
                if (newVal) {
                    // on loader start
                    this.start();
                } else {
                    // on loader complete
                    this.complete();
                }
            }
        }
    },
    methods: {
        /**
         * Set the loading bar's width to a certain percent.
         *
         * @param n any value between 0 and 1
         */
        setValue(n) {
            if (!this.started) {
                return;
            }
            this.width = `${n * 100}%`;

            this.barPercentageValue = n;

            // increment loading bar to give the illusion that there is always
            // progress but make sure to cancel the previous timeouts so we don't
            // have multiple incs running at the same time.
            if (this.incTimeout) {
                clearTimeout(this.incTimeout);
            }
            this.incTimeout = setTimeout(() => {
                this.incrementValue();
            }, 450);
        },
        /**
         * Increments the loading bar by a random amount
         * but slows down as it progresses
         */
        incrementValue() {
            const currentPercentageValue = this.barPercentageValue;
            if (currentPercentageValue >= 1) {
                return;
            }

            let rnd = 0;

            if (currentPercentageValue >= 0 && currentPercentageValue < 0.45) {
                // Start out between 3 - 6% increments
                rnd = (Math.random() * (4) + 10) / 100;
            } else if (currentPercentageValue >= 0.45 && currentPercentageValue < 0.75) {
                // increment between 0 - 10%
                rnd = (Math.random() * 10) / 100;
            } else if (currentPercentageValue >= 0.75 && currentPercentageValue < 0.9) {
                // increment between 0 - 2%
                rnd = (Math.random() * 2) / 100;
            } else if (currentPercentageValue >= 0.9 && currentPercentageValue < 0.99) {
                // finally, increment it .5 %
                rnd = 0.005;
            } else {
                // after 99%, don't increment:
                rnd = 0;
            }

            const pct = currentPercentageValue + rnd;
            this.setValue(pct);
        },
        start() {
            this.started = true;
            this.showLoader = true;
            this.setValue(0.001);
        },
        async complete() {
            this.setValue(1);
            this.started = false;
            await timeoutPromise(600);
            this.showLoader = false;
        }
    }
};

</script>

<style scoped lang="scss">
@import "~styles/styleGuide";
.page-Loader {
    transition: width 450ms ease-in;
    transform: translate3d(0,0,0);
    position: absolute;
    height: 1px;
    left:0;
    width:0;
    background: $primaryColor;
    opacity:1;
    z-index:100;
    bottom: 0;
}
</style>
